import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { Link } from 'react-router-dom'
import { Tooltip, OverlayTrigger  } from 'react-bootstrap'

import API from 'utils/api/api'
import API_V1_URL from 'utils/api/urls_v1'
import ObjectTools from 'utils/objects/objectTools'
import DataTools from 'utils/dataTools'
import IndicatorTools from 'utils/indicators/indicatorTools'

import Loading from 'components/Loading'
import Error from 'components/Error'

import messages from './messages'


function createSimpleTooltip(text, tooltip) {
	let noteTooltip = <Tooltip id="tooltip" className='tooltip-note'>
		{tooltip}
		</Tooltip>;

	return (
		<React.Fragment>
			<OverlayTrigger overlay={noteTooltip} placement="top">
				<Link to="#">{text}</Link> 
			</OverlayTrigger>
		</React.Fragment>
	);
}


const seriesDateValue = (series, time) => {
	return DataTools.arrayAt( series.filter((s) => (s && (s["time"] === time))), 0 );
};

const extractYearFromDateStr = (date_str) => {
	if (date_str) {
		return parseInt(date_str.substring(0, 4), 10);
	} else {
		return null;
	}
}

// const lastPeriodString = (times) => {
// 	// times: array of string times
// 	return times.at(-2).substring(0, 4) + "-" + times.at(-1).substring(2, 4);
// }

const prevPeriodString = (commonData) => {
	// times: array of string times
	return commonData.prev["rg"].time.substring(0, 4) + "-" + commonData.last["rg"].time.substring(2, 4);
}

const compareValues = (v, v_ref, tolerances, useAbsoluteTolerances) => {
	// tolerances is a list of thresholds (positive)
	// it has to contain at least one value
	// the first threshold is for equality (make it zero to force equality)
	// tolerances are percentual to ref value if ot useAbolsuteToleraces =true: then tolerances are the absolute values
	if (v == null || v_ref == null) {
		return null;
	} else {
		const diff = v - v_ref;
		const abs_diff = Math.abs(diff);

		// if v_ref == 0 we use the first tolerance step because if not it will tend to infinity
		if ( v_ref === 0 ) {
			let l = tolerances.length === 1 ? 0 : 1;
			return l * Math.sign( diff );
		}

		let l = 0;
		for (; l < tolerances.length; l++ ) {
			let abs_threshold = Math.abs(v_ref) * tolerances[l];
			if ( useAbsoluteTolerances === true ) {
				abs_threshold = tolerances[l];
			}
			if ( abs_diff < abs_threshold ) {
				break; // exit and return current level
			}
		}
		return l * Math.sign( diff );
	}
};


class ReportTableRowValues extends Component {
	constructor(props) {
		super(props)

		this.state = {
			loading: true,
			error: false
		}

		const {
			intl: { formatNumber, formatMessage }
		} = props

		this.formatNumber = formatNumber
		this.formatMessage = formatMessage
	}

	static getDerivedStateFromProps(nextProps, prevState) {
		if (nextProps !== prevState) {
			return nextProps
		}

		return null
	}

	componentDidMount() {
		this.getData();
		// this.getRankingChart();
	}

	shouldComponentUpdate(nextProps, nextState) {
		const shouldUpdate = !ObjectTools.compareObjects(this.props, nextProps) || !ObjectTools.compareObjects(this.state, nextState)

		return shouldUpdate
	}

	componentDidUpdate(prevProps) {
		if (prevProps !== this.props) {
			this.setState({ loading: true, error: false, regionsData: JSON.parse(this.props.regionsData) }, () => this.getData())
		}
	}

	getData = (
		{ indicator, selectedRegionId, comparative } = {
			indicator: this.props.indicatorData.id,
			selectedRegionId: this.props.selectedRegionId,
			comparative: this.props.comparative
		}
	) => {
		let promises = [];

		// get time series for all needed regions: reg, country, eu
		// maybe get all the series for benchmarkregions plus country and eu and work with all that?
		let countryId = this.props.topLevelRegions["ctry"];
		let euId = this.props.topLevelRegions["eu"];
		let geo = [
			selectedRegionId,
			countryId,
			euId
		]
		// const generalPromise = Promise.resolve(API.getQuery( API_V1_URL.getIndicatorData({ indicator, geo })))
		// promises.push(generalPromise);

		const regionsData = JSON.parse(this.props.regionsData);
		const benchmarkRegionIds = regionsData.map( o => o[ "id" ] );
		benchmarkRegionIds.forEach( (geo_id) => {
			if ( geo_id !== selectedRegionId ) {
				geo.push( geo_id );
			}
		} );

		// v1 hispeed
		const completePromise = Promise.resolve(API.getQuery( API_V1_URL.getIndicatorData({ indicator, geo })));
		const geo_key = "geo";
		// v0 facade
		// const completePromise = Promise.resolve(API.getQuery( API_V1_URL.getIndicatorDataV0Facade({ indicator, geo })));
		// const geo_key = "geoset";
		promises.push(completePromise);

		Promise.all(promises)
		.then( values => {
			let data = values[0].data.sort( (a, b) => {
				return DataTools.ascending( a["time"], b["time"] );
			} );

			let summary = {
						"last": {},
						"prev": null,
						"delta": null,
						"delta_pc": null,
						"series": {},
						"common": null,
						"short": null
					};
			let timeseries = {};
			timeseries["rg"] = data.filter( d => (d["value"] != null & d[geo_key] === selectedRegionId));
			timeseries["eu"] = data.filter( d => (d["value"] != null & d[geo_key] === euId));
			summary["series"] = timeseries;

			let timeDelta = 1;

			// available times
			let times = [];
			times["rg"] = DataTools.uniquePropertyValues( summary["series"]["rg"], "time" ).sort(DataTools.ascending);
			times["eu"] = DataTools.uniquePropertyValues( summary["series"]["eu"], "time" ).sort(DataTools.ascending);
			summary["times"] = times;

			// regionTimes
			let regionYears = times["rg"].map( d => extractYearFromDateStr( d ) );
			let prevRegionTimeIndex = findPrevDeltaYearIndex( regionYears, timeDelta );

			// find common years
			let commonTimes = DataTools.intersection( ["rg", "eu"].map( series => times[series] ) ).sort(DataTools.ascending);
			let commonYears = commonTimes.map( d => extractYearFromDateStr( d ) );
			// console.log( "commonyears", commonYears );
			let prevCommonTimeIndex = findPrevDeltaYearIndex( commonYears, timeDelta );

			// short common times for dsplay purposes: combines available period for region and for eu
			let shortTimes = new Set();
			shortTimes.add( times["rg"].at(-1) );						// region last year
			shortTimes.add( times["rg"].at( prevRegionTimeIndex ) );	// region prev year
			// shortTimes.add( DataTools.arrayAt( commonTimes, -1 ) );
			// shortTimes.add( DataTools.arrayAt( commonTimes, -2 ) );
			shortTimes.add( commonTimes.at( -1 ) );						// common last year
			shortTimes.add( commonTimes.at( prevCommonTimeIndex ) );	// common prev year
			shortTimes = Array.from(shortTimes).sort(DataTools.ascending);
			let shortYears = shortTimes.map( d => extractYearFromDateStr( d ) );
			// remove undefined values
			shortTimes = shortTimes.filter(t => t);			
			let prevShortTimeIndex = findPrevDeltaYearIndex( shortYears, timeDelta );

			// console.log( "shortyears", shortYears );
			// console.log( "prevShortTimeIndex", prevShortTimeIndex );

			// reduced series for smaller table
			let shortSeries = {};
			shortSeries["rg"] = shortTimes.map( t => seriesDateValue( timeseries["rg"], t ) );
			shortSeries["eu"] = shortTimes.map( t => seriesDateValue( timeseries["eu"], t ) );
			summary["short"] = {};
			summary["short"]["times"] = shortTimes;
			summary["short"]["series"] = shortSeries;

			// common series for comparison
			let commonSeries = {};
			commonSeries["rg"] = commonTimes.map( t => seriesDateValue( timeseries["rg"], t ) );
			commonSeries["eu"] = commonTimes.map( t => seriesDateValue( timeseries["eu"], t ) );

			summary["last"]["rg"] = shortSeries["rg"].at( -1 );
			summary["last"]["eu"] = shortSeries["eu"].at( -1 );

			this.props.updateTime( summary["last"]["rg"].time_display, DataTools.arrayAt( summary["series"]["rg"], -1 ).time_display );
			
			let deltaValue = (v0, v1) => {
				if (v0 && v0["value"] !== null && v1 && v1["value"] !== null) {
					return v1["value"] - v0["value"];
				}
				return null;
			};

			let pcDeltaValue = (v0, v1) => {
				if (v0 && v0["value"] !== null && v1 && v1["value"] !== null && v1["value"] !== 0.0) {
					return (v1["value"] - v0["value"]) / v0["value"];
				}
				return null;
			};


			function findPrevDeltaYearIndex(commonYears, yearDelta) {
				let lastYear = commonYears.at( -1 );
				let prevYear = lastYear - yearDelta;

				// let's find
				// for (let i = 0; i < commonYears.length; i++ ) {
				// 	if ( commonYears[i] >= prevYear ) {
				// 		return i;
				// 	}
				// }

				for (let i = commonYears.length - 1; i >= 0; i-- ) {
					if ( commonYears[i] <= prevYear ) {
						return i;
					}
				}

				// if not found and length > 1 we return the last year
				if ( commonYears.length > 1 ) {
					return 0;
				}

				// else, no comparison
				return null;
			}

			// console.log( "indicador: " + indicator );


			if ( times["rg"].length > 1 ) {
				summary["prev"] = {};
				summary["prev"]["rg"] = shortSeries["rg"].at( prevShortTimeIndex );

				summary["delta"] = {};
				summary["delta"]["rg"] = deltaValue( shortSeries["rg"].at( prevShortTimeIndex ), shortSeries["rg"].at( -1 ) );

				summary["delta_pc"] = {};
				summary["delta_pc"]["rg"] = pcDeltaValue( shortSeries["rg"].at( prevShortTimeIndex ), shortSeries["rg"].at( -1 ) );
			}




			summary["common"] = {};
			summary["common"]["times"] = commonTimes;
			summary["common"]["series"] = commonSeries;
			summary["common"]["last"] = {};
			summary["common"]["last"]["rg"] = commonSeries["rg"].at( -1 );
			summary["common"]["last"]["eu"] = commonSeries["eu"].at( -1 );

			summary["common"]["prev"] = {};
			// summary["common"]["prev"]["rg"] = commonSeries["rg"].at( -2 );
			// summary["common"]["prev"]["eu"] = commonSeries["eu"].at( -2 );
			summary["common"]["prev"]["rg"] = commonSeries["rg"].at( prevCommonTimeIndex );
			summary["common"]["prev"]["eu"] = commonSeries["eu"].at( prevCommonTimeIndex );

			summary["common"]["delta"] = {};
			// summary["common"]["delta"]["rg"] = deltaValue( commonSeries["rg"].at( -2 ), commonSeries["rg"].at( -1 ) );
			// summary["common"]["delta"]["eu"] = deltaValue( commonSeries["eu"].at( -2 ), commonSeries["eu"].at( -1 ) );
			summary["common"]["delta"]["rg"] = deltaValue( summary["common"]["prev"]["rg"], summary["common"]["last"]["rg"] );
			summary["common"]["delta"]["eu"] = deltaValue( summary["common"]["prev"]["eu"], summary["common"]["last"]["eu"] );

			summary["common"]["delta_pc"] = {};
			// summary["common"]["delta_pc"]["rg"] = pcDeltaValue( commonSeries["rg"].at( -2 ), commonSeries["rg"].at( -1 ) );
			// summary["common"]["delta_pc"]["eu"] = pcDeltaValue( commonSeries["eu"].at( -2 ), commonSeries["eu"].at( -1 ) );
			summary["common"]["delta_pc"]["rg"] = pcDeltaValue( summary["common"]["prev"]["rg"], summary["common"]["last"]["rg"] );
			summary["common"]["delta_pc"]["eu"] = pcDeltaValue( summary["common"]["prev"]["eu"], summary["common"]["last"]["eu"] );

			// console.log(summary)

			let rowData = this.prepareRowData( summary );
			this.props.sendDataUp( this.props.indicator, rowData );

			this.setState({ summary: summary, rowData: rowData, loading: false });
		})
		.catch(reason => {
			console.log( reason );
			this.setState({ error: true, loading: false })
		});
	}

	orderingSignedValue = (v) => {
		// console.log(v, this.props.indicatorData);
		if ( v == null ) {
			return null;
		} else if ( this.props.indicatorData.rankOrdering === "ascending" ) {
			return -v;
		} else {
			return v;
		}
	}

	prepareRowData(summary) {		
		let formattedValue = {};
		Object.keys( summary.last ).forEach( area => {
			if ( summary.last[area] && summary.last[area].value ) {
				formattedValue[area] = this.formatValueSimple( summary.last[area].value );
				// tooltip[area] = getValueTooltip( this.state.summary, area );
			} else {
				formattedValue[area] = "n/a";
				// tooltip[area] = <Tooltip id="tooltip"></Tooltip>;
			}
		} );

		// let rgPrevYearDelta = this.state.summary.delta["rg"];

		const commonData = summary.common;
		const last_rg = summary.last["rg"].value;
		const prev_rg = summary.prev["rg"].value;
		const rg_last_time = summary.last["rg"].time;
		let common_last_rg = commonData.last["rg"] ? commonData.last["rg"].value : null;
		let common_last_eu = commonData.last["eu"] ? commonData.last["eu"].value : null;
		let common_pchg_rg = commonData.delta_pc["rg"];
		let common_pchg_eu = commonData.delta_pc["eu"];

		let eu27_last_time = commonData.last["eu"] ? commonData.last["eu"].time : null;
		// let common_period = null;
		if ( eu27_last_time ) {
			// if last EU27 is more than 3 years apart from region data, hide it 
			if ( (extractYearFromDateStr(summary.last["rg"].time) - extractYearFromDateStr(eu27_last_time)) > 3 ) {
				common_last_eu = null;
				common_pchg_eu = null;
				eu27_last_time = null;
			}
		}

		let tolerances = [ 0.01, 0.05 ];
		let tolerancesAbs3 = [ 0.005, 0.03 ];

		let comparisonEvoRg = this.orderingSignedValue(compareValues(last_rg, prev_rg, tolerances));
		let comparisonLvlEU = this.orderingSignedValue(compareValues(common_last_rg, common_last_eu, tolerances));
		let comparisonEvoEU = this.orderingSignedValue(compareValues(common_pchg_rg, common_pchg_eu, tolerancesAbs3, true));

		const indicatorName = IndicatorTools.cleanIndicatorName( this.props.indicatorData.name );
		const indicatorUnit = IndicatorTools.cleanIndicatorUnit( this.props.indicatorData.unit );

		// prepare data row
		let rowData = {
			"name":				indicatorName,
			"unit":				indicatorUnit,
			"last_rg_year":		extractYearFromDateStr(rg_last_time),
			"last_rg_value":	last_rg,
			"comparisonEvoRg":	comparisonEvoRg,
			// "last_rg_evo":		comparisonIcons(comparisonEvoRg, COMPARISON_ARROWS_LR),
			"vs_eu27_year":		extractYearFromDateStr(eu27_last_time),
			"vs_eu27_value":	null,
			"comparisonLvlEU":	comparisonLvlEU,
			"comparisonEvoEU":	comparisonEvoEU
			// "vs_eu27_level":	comparisonIcons(comparisonLvlEU, COMPARISON_ARROWS_UD),
			// "vs_eu27_evo":		comparisonIcons(comparisonEvoEU, COMPARISON_PLUSMINUS)
		};

		return rowData;
	}

	formatValue(v, minFractionDigits = 0 ) {
		if ( v == null ) {
			return this.formatMessage( messages.notAvailableShort );
		}
		return IndicatorTools.formatValue( v, this.props.indicatorData.unit, minFractionDigits );
	}

	formatValueSimple(v) {
		if ( v == null ) {
			return this.formatMessage( messages.notAvailableShort );
		}
		return IndicatorTools.formatValue( v, "", this.props.precision );
	}

	renderIfAllOK = () => {
		let renderingComponent = null;
		// let unit = this.props.indicatorData.unit;

		// const COMPARISON_ARROWS_UD = [ "\u2191", "\u2193", "=" ];
		// const COMPARISON_ARROWS_LR = [ "\u2192", "\u2190", "=" ];
		// const COMPARISON_PLUSMINUS = [ "+", "-", "=" ];

		const COMPARISON_ICONS_ARROWS_UD = [ "arrow-up", "arrow-down", "equals" ];
		const COMPARISON_ICONS_ARROWS_LR = [ "arrow-right", "arrow-left", "equals" ];
		const COMPARISON_ICONS_PLUSMINUS = [ "plus", "minus", "equals" ];

		const getIcon = (name, key) => {
			return <React.Fragment key={key}><i className={"fal fa-"+name}/></React.Fragment>;
		}

		const comparisonIcons = (count, strings) => {
			let icons = [];
			if (count == null ) {
				return this.formatMessage( messages.notAvailableShort );
			} else if ( count > 0 ) {
				while( count-- ) {
					icons.push(getIcon(strings[0], count))
				}
				// resultString = strings[0].repeat(count);
			} else if ( count < 0 ) {
				while( count++ ) {
					icons.push(getIcon(strings[1], count))
				}
				// resultString = strings[1].repeat(-count);
			} else {
				// resultString = strings[2];
				icons.push(getIcon(strings[2], count))
			}
			return <React.Fragment>{icons}</React.Fragment>;
		}

		const ignoreColor = this.props.ignoreColor;
		const cellColor = (v) => {
			if ( ignoreColor || (v == null) ) {
				return "";
			} else if ( v > 0 ) {
				return "positive";
			} else if ( v < 0 ) {
				//return <React.Fragment><span>{"\u2193"}</span></React.Fragment>;
				return "negative";
			} else {
				return "stable";
			}
		}

		const getValueTooltip = (summary_data, highlight) => {
			let shortData 	= summary_data["short"];
			let shortTimes 	= shortData["times"];
			let shortSeries = shortData["series"];
			// add common change values
			let commonData = summary_data["common"];

			let regionPeriodTimes = [];
			if ( summary_data.prev["rg"] ) {
				regionPeriodTimes.push( summary_data.prev["rg"].time );
			}
			regionPeriodTimes.push( summary_data.last["rg"].time );

			// selective highlighting
			let highlightEvoRg = '';
			let highlightLvlEU = '';
			let highlightEvoEU = '';
			if ( highlight !== undefined ) {
				if ( "evo_rg" in highlight ) {
					highlightEvoRg = cellColor( highlight["evo_rg"] );
				} else if ( "lvl_eu" in highlight ) {
					highlightLvlEU = cellColor( highlight["lvl_eu"] );
				} else if ( "evo_eu" in highlight ) {
					highlightEvoEU = cellColor( highlight["evo_eu"] );
				}
			}

			const timeHeaders = [];
			const rgValues = [];
			const euValues = [];
			let i = 0; // use as key for react things
			for ( /* let i = 0 */; i < shortTimes.length; i++ ) {
				let t = shortTimes[i];
				if ( t ) {
					let v_rg = seriesDateValue( shortSeries["rg"], t );
					v_rg = v_rg ? v_rg["value"] : v_rg;
					let v_eu = seriesDateValue( shortSeries["eu"], t );
					v_eu = v_eu ? v_eu["value"] : v_eu;

					let rgClassName = '';
					let euClassName = '';

					// if ( highlightEvoRg && (i >= (shortTimes.length - 2) ) ) {
					if ( highlightEvoRg && (regionPeriodTimes.includes(shortTimes[i])) ) {
						rgClassName = highlightEvoRg;
					} else if ( highlightLvlEU && commonData && (t === commonData.times.at(-1) ) ) {
						rgClassName = highlightLvlEU;
						euClassName = highlightLvlEU;
					}
					
					timeHeaders.push(<th key={i} className='text-right'>{t.substring(0, 4)}</th>)
					rgValues.push(<td key={i} className={rgClassName}>
									{this.formatValueSimple( v_rg )}
								</td>);
					euValues.push(<td key={i} className={euClassName}>
									{this.formatValueSimple( v_eu )}
								</td>);
				}
			}


			// and region change values if different any of last two years
			let rgTimes = summary_data["times"]["rg"];
			let rgEvoSingleDisplay = false;

			if (commonData.times && commonData.times.length > 1) {
				// check if periods are the same
				if ( (extractYearFromDateStr(commonData.times.at(-1)) !== extractYearFromDateStr(rgTimes.at(-1))) ||
					 (extractYearFromDateStr(commonData.times.at(-2)) !== extractYearFromDateStr(rgTimes.at(-2))) ) {
				   	rgEvoSingleDisplay = true;
			   	}

				let rgClassName = highlightEvoEU;
				let euClassName = highlightEvoEU;

				if ( highlightEvoRg && !rgEvoSingleDisplay ) {
					rgClassName = highlightEvoRg;
				}

				rgValues.push(<td key={i} className={rgClassName}>
					{this.formatValue( commonData.delta_pc["rg"]*100, 1 )}%
				</td>);
				euValues.push(<td key={i} className={euClassName}>
					{this.formatValue( commonData.delta_pc["eu"]*100, 1 )}%
				</td>);
				// timeHeaders.push(<th key={i} className=''>{lastPeriodString(commonData.times)}</th>)
				timeHeaders.push(<th key={i} className=''>{prevPeriodString(commonData)}</th>);

				i++; // another key
			} else {
				rgEvoSingleDisplay = true;
			}

			if ( rgEvoSingleDisplay ) {
				rgValues.push(<td key={i} className={highlightEvoRg}>
					{this.formatValue( summary_data.delta_pc["rg"]*100, 1 )}%
				</td>);
				euValues.push(<td key={i} className=''>
					{this.formatValue( null )}
				</td>);
				// timeHeaders.push(<th key={i} className={highlightEvoRg}>{lastPeriodString(rgTimes)}</th>);
				timeHeaders.push(<th key={i} className={highlightEvoRg}>{prevPeriodString(summary_data)}</th>);
			}

			return <Tooltip id="tooltip" className='tooltip-values'>
				<table className='report-table-tooltip-values'>
					<thead>
						<tr>
							<th></th>
							{timeHeaders}
						</tr>
					</thead>
					<tbody>
						<tr>
							<td className='text-left'>región</td>
							{rgValues}
						</tr>
						<tr>
							<td className='text-left'>EU27</td>
							{euValues}
						</tr>
					</tbody>
				</table>
			</Tooltip>;
		};

		if (this.state.error) {
			renderingComponent = <React.Fragment>
					<Error />
			</React.Fragment>;
		} else if (this.state.loading) {
			renderingComponent = <React.Fragment>
					<Loading />
			</React.Fragment>;
		} else {
			const summary = this.state.summary;
			let formattedValue = {};
			Object.keys( summary.last ).forEach( area => {
				if ( summary.last[area] && summary.last[area].value ) {
					formattedValue[area] = this.formatValueSimple( summary.last[area].value );
					// tooltip[area] = getValueTooltip( this.state.summary, area );
				} else {
					formattedValue[area] = "n/a";
					// tooltip[area] = <Tooltip id="tooltip"></Tooltip>;
				}
			} );

			// let rgPrevYearDelta = this.state.summary.delta["rg"];

			/*
			const commonData = summary.common;
			const last_rg = summary.last["rg"].value;
			const prev_rg = summary.prev["rg"].value;
			const rg_last_time = summary.last["rg"].time;
			let common_last_rg = commonData.last["rg"] ? commonData.last["rg"].value : null;
			let common_last_eu = commonData.last["eu"] ? commonData.last["eu"].value : null;
			let common_pchg_rg = commonData.delta_pc["rg"];
			let common_pchg_eu = commonData.delta_pc["eu"];

			let eu27_last_time = commonData.last["eu"] ? commonData.last["eu"].time : null;
			// let common_period = null;
			if ( eu27_last_time ) {
				// if last EU27 is more than 3 years apart from region data, hide it 
				if ( (extractYearFromDateStr(summary.last["rg"].time) - extractYearFromDateStr(eu27_last_time)) > 3 ) {
					common_last_eu = null;
					common_pchg_eu = null;
					eu27_last_time = null;
				} //else {
					// common_period = lastPeriodString(commonData.times);
				//}
			}

			let tolerances = [ 0.01, 0.05 ];
			// let tolerances25 = [ 0.01, 0.25 ];
			let tolerancesAbs3 = [ 0.005, 0.03 ];

			let comparisonEvoRg = this.orderingSignedValue(compareValues(last_rg, prev_rg, tolerances));
			let comparisonLvlEU = this.orderingSignedValue(compareValues(common_last_rg, common_last_eu, tolerances));
			let comparisonEvoEU = this.orderingSignedValue(compareValues(common_pchg_rg, common_pchg_eu, tolerancesAbs3, true));
			*/

			const rowData = this.state.rowData;
			const indicatorUnit = IndicatorTools.cleanIndicatorUnit( this.props.indicatorData.unit );

			renderingComponent = <React.Fragment>
				<div className="row">

					<div key="0" className="col-lg-2 visible-lg report-table-cell-value">{rowData["last_rg_year"]}</div>

					<div key="1" className="hidden-lg col-md-6 col-xs-6 report-table-mini-head">Valor</div>
					<div key="2" className="hidden-lg col-md-2 col-xs-2 report-table-mini-head text-center">{createSimpleTooltip("Evo", "Evolución desdel el último año")}</div>
					<div key="3" className="hidden-lg col-md-2 col-xs-2 report-table-mini-head text-center">{createSimpleTooltip("EU27 Pos", "Posición relativa respecto EU-27")}</div>
					<div key="4" className="hidden-lg col-md-2 col-xs-2 report-table-mini-head text-center">{createSimpleTooltip("EU27 Evo", "Comparación evolución respecto EU-27")}</div>

					<div key="5" className="col-lg-2 col-md-6 col-xs-6 text-left">
						<OverlayTrigger overlay={getValueTooltip(summary)} placement="top">
							<Link to="#">
								{formattedValue["rg"]}<span className="hidden-lg report-indicator-unit"> {indicatorUnit}</span>
							</Link>
						</OverlayTrigger>
					</div>

					<div key="6" className={'col-lg-2 col-md-2 col-xs-2 report-table-cell-icons ' + cellColor(rowData["comparisonEvoRg"])}>
						<OverlayTrigger overlay={getValueTooltip(summary, {"evo_rg": rowData["comparisonEvoRg"]})} placement="top">
							<Link to="#">
								{comparisonIcons(rowData["comparisonEvoRg"], COMPARISON_ICONS_ARROWS_LR)}
							</Link>
						</OverlayTrigger>
					</div>

					<div key="7" className="col-lg-2 visible-lg report-table-cell-value">
						{rowData["vs_eu27_year"]}
					</div>

					<div key="8" className={"col-lg-2 col-md-2 col-xs-2 report-table-cell-icons " + cellColor(rowData["comparisonLvlEU"])}>
						{rowData["comparisonLvlEU"] !== null ? 
						(<OverlayTrigger overlay={getValueTooltip(summary, {"lvl_eu": rowData["comparisonLvlEU"]})} placement="left">
							<Link to="#">
								{comparisonIcons(rowData["comparisonLvlEU"], COMPARISON_ICONS_ARROWS_UD)}
							</Link>
						</OverlayTrigger>):
						(this.formatMessage( messages.notAvailableShort ))}
					</div>					

					<div key="9" className={"col-lg-2 col-md-2 col-xs-2 report-table-cell-icons " + cellColor(rowData["comparisonEvoEU"])}>
						{rowData["comparisonEvoEU"] !== null ? 
						(<OverlayTrigger overlay={getValueTooltip(summary, {"evo_eu": rowData["comparisonEvoEU"]})} placement="left">
							<Link to="#">
								{comparisonIcons(rowData["comparisonEvoEU"], COMPARISON_ICONS_PLUSMINUS)}
							</Link>
						</OverlayTrigger>):
						(this.formatMessage( messages.notAvailableShort ))}
					</div>
					<div key="10" className={"col-12 hidden-lg"}>&nbsp;</div>
				</div>
			</React.Fragment>
		}
		return renderingComponent
	}

	render() {
		return <React.Fragment>{this.renderIfAllOK()}</React.Fragment>
	}
}

export default injectIntl(ReportTableRowValues)



// WEBPACK FOOTER //
// ./src/modules/Charts/ReportTableRow/ReportTableRowValues/ReportTableRowValues.jsx